import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/editSobTarget.css";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";

const EditSOBTarget = () => {
  const [states, setStates] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [targets, setTargets] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    target: "",
    start_date: ""
  });

  // Fetch states on mount
  useEffect(() => {
    fetch(`${BASE_URL}/api/states`, {
      headers: getAuthHeaders()
    })
      .then((res) => res.json())
      .then((data) => setStates(data));
  }, []);

  // Fetch employees when state changes
  useEffect(() => {
    if (selectedState) {
      axios.get(`${BASE_URL}/api/employees?state_id=${selectedState}`, {
        headers: getAuthHeaders()
      })
        .then(res => setEmployees(res.data))
        .catch(err => console.error(err));
    }
  }, [selectedState]);

  // Handle GO button click
  const handleGoClick = () => {
    if (!selectedEmployee) {
      alert("Please select an employee");
      return;
    }
    fetchTargets();
  };

  // Fetch targets for selected employee
  const fetchTargets = () => {
    axios.get(`${BASE_URL}/api/sob-targets/employee/${selectedEmployee}`, {
      headers: getAuthHeaders()
    })
      .then(res => {
        setTargets(res.data);
        setShowTable(true);
      })
      .catch(err => console.error(err));
  };

  // Handle edit button click
  const handleEdit = (target) => {
    setEditingId(target.id);
    setEditForm({
      target: target.target,
      start_date: target.start_date.split('T')[0]
    });
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({ ...prev, [name]: value }));
  };

  // Save edited target
  //  const handleSave = async (id) => {
  //     try {
  //       // 1. Find the target being edited
  //       const targetToEdit = targets.find(t => t.id === id);
  //       if (!targetToEdit) {
  //         throw new Error('Target data not found');
  //       }

  //       // 2. Prepare update data
  //       const updateData = {
  //         target: parseFloat(editForm.target),
  //         start_date: editForm.start_date || new Date().toISOString().split('T')[0],
  //         // Backend will handle end_date logic
  //       };

  //       // 3. Send update request
  //       const response = await axios.put(
  //         `${BASE_URL}/api/sob-targets/${id}`,
  //         updateData
  //       );

  //       // 4. Update local state
  //       setTargets(prev => prev.map(item => 
  //         item.id === id ? response.data : item
  //       ));

  //       setEditingId(null);
  //       alert('Target updated successfully!');

  //     } catch (error) {
  //       console.error("Update failed:", error);
  //       alert(error.response?.data?.detail || error.message || 'Update failed');
  //       setEditingId(null);
  //     }
  //   };

  const handleSave = async (id) => {
    try {
      // 1. Find target
      const targetToEdit = targets.find(t => t.id === id);
      if (!targetToEdit) throw new Error('Target not found');

      // 2. Prepare update
      const updateData = {
        target: parseFloat(editForm.target),
        start_date: editForm.start_date || targetToEdit.start_date
      };

      // 3. Send update
      const { data } = await axios.put(
        `${BASE_URL}/api/sob-targets/${id}`,
        updateData,
        {
          headers: getAuthHeaders()
        }
      );


      // 4. Update UI
      setTargets(prev => prev.map(t =>
        t.id === id ? {
          ...t,
          target: data.target,
          start_date: data.start_date,
          end_date: data.end_date || t.end_date
        } : t
      ));

      setEditingId(null);
      alert('Updated successfully!');

    } catch (error) {
      console.error("Update failed:", error);
      alert(error.response?.data?.detail || 'Update failed');
      setEditingId(null);
    }
  };

  // Handle delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this target?")) {
      try {
        await axios.delete(`${BASE_URL}/api/sob-targets/${id}`, {
          headers: getAuthHeaders()
        });
        fetchTargets(); // Refresh data
        alert("Target deleted successfully!");
      } catch (error) {
        console.error("Error deleting target:", error);
        alert("Failed to delete target");
      }
    }
  };

  return (
    <div className="edit-sob-main-container">
      <Header />
      <Navbar />
      {/* Filter Section */}
      <div className="editsob-filter-section">
          <h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4"><span class="text-blue-700">Select </span><span class="text-blue-500">Employee</span></h1>

        <div className="filter-col1">
          <label>State:</label>
          <select
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
          >
            <option value="">Select State</option>
            {states.map(state => (
              <option key={state.id} value={state.id}>{state.name}</option>
            ))}
          </select>
          {/* </div>

        <div className="filter-col2"> */}
          <label>Employee:</label>
          <select
            value={selectedEmployee}
            onChange={(e) => setSelectedEmployee(e.target.value)}
          >
            <option value="">Select Employee</option>
            {employees.map(emp => (
              <option key={emp.id} value={emp.id}>
                {emp.first_name} {emp.last_name} | {emp.employee} | {emp.designation} | {emp.division} | {emp.state_name}
              </option>
            ))}
          </select>
        </div>

        <button className="editsobgo-button" onClick={handleGoClick}>
          GO
        </button>
      </div>

      {/* Table Container */}
      {showTable && (
        <div className="editsob-table-container">
          {/* <div className="editsob-title2-container">
            <h2 className="editsob-title2">SOB Target Details { }</h2>
          </div> */}
          <table className="sob-table">
            <thead className="text-white">
              <tr>
                <th>S.No</th>
                <th>SOB Target</th>
                <th>Start</th>
                <th>End</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {targets.map((target, index) => (
                <tr key={target.id}>
                  <td>{index + 1}</td>
                  <td>
                    {editingId === target.id ? (
                      <input
                        type="number"
                        name="target"
                        value={editForm.target}
                        onChange={handleInputChange}
                      />
                    ) : (
                      target.target.toFixed(2)
                    )}
                  </td>
                  <td>
                    {editingId === target.id ? (
                      <input
                        type="date"
                        name="start_date"
                        value={editForm.start_date}
                        onChange={handleInputChange}
                      />
                    ) : (
                      new Date(target.start_date).toLocaleDateString()
                    )}
                  </td>
                  <td>
                    {target.end_date
                      ? new Date(target.end_date).toLocaleDateString()
                      : "Till Next Change"}
                  </td>
                  <td>
                    <div className="editsob-actions-container">
                      {editingId === target.id ? (
                        <>
                          <button className="editsob-save-button" onClick={() => handleSave(target.id)}>Save</button>
                          <button className="editsob-cancel-button" onClick={() => setEditingId(null)}>Cancel</button>
                        </>
                      ) : (
                        <>
                          <button className="editsob-edit-button" onClick={() => handleEdit(target)}>Edit</button>
                          <button className="editsob-delete-button" onClick={() => handleDelete(target.id)}>Delete</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default EditSOBTarget;